/**
@ngdoc directive
@name validationRemote

@description
- the callback should return true for valid field
- please use {viewValue} if you want to use your model on the field - if the value is invalid the model won't be updated hence
  we need to use $viewValue instead of $modelValue
- validation-remote directive name reflects the validator name to let optimized xms-validation work without additional
  (validator name) attribute on the field
- validation-remote can use the server response as the validation error message - just please specify remote-validation-message="true" attribute
 - please encode any strings containing URI reserved characters before passing to validation-remote-datasrc - e.g., URLEncoder.encode('person1&person2@test.com','UTF-8')

@usage
Please refer to testUi (former testValidation).
*/

(function() {

    var validationRemote = function($q, $timeout, $http, $compile, transformToFormPost){
        return {
            scope: true,
            require: ['ngModel', '^form'],
            priority:-10,
            link: function(scope, element, attrs, ctrls) {

                var ngModel = ctrls[0],
                    isErrorBox = false;

                $timeout(function(){

                    scope.form  = ctrls[1];
                    scope.fieldName = element.attr('name');

                    element.wrap('<div class="spinner-input-box"></div>');
                    element.after( $compile('<i ng-show="form[fieldName].$pending[\'validation-remote\']" class="validation-remote-spinner loading-spinner"></i>')(scope) );


                    // we need to watch data and revalidate if it changes
                    attrs.$observe('validationRemoteDatasrc', function(val) {
                        scope.form[scope.fieldName].$validate();
                    });


                    ngModel.$asyncValidators['validation-remote'] = function(modelValue, viewValue){

                        if (!viewValue) {
                            return $q.when(true);
                        }
                        var deferred = $q.defer();


                            $http({
                                method: 'POST',
                                url: WEBAPP_PATH + attrs.validationRemote,
                                data: attrs.validationRemoteDatasrc.replace('{viewValue}', encodeURIComponent(viewValue)),
                                transformRequest: transformToFormPost,
                            }).then(function successCallback(response) {
                                if(angular.isDefined(response.data) && (response.data===true || response.data==="true") ){
                                    deferred.resolve();
                                } else {
                                    if(angular.isDefined(response.data) && response.data!==false && response.data!=="false" ){
                                        scope.remoteValidationErrorMsg = response.data;
                                    }
                                    deferred.reject();
                                }
                                delete scope.connectionError;
                            }, function errorCallback(response) {
                                if(!isErrorBox){
                                    // add error message if it's not there yet
                                    element.parent().after( $compile('<small ng-if="connectionError" class="text-danger">{{connectionError}}</small>')(scope) );
                                    isErrorBox = true;
                                }
                                console.log(response);
                                scope.connectionError = "Connection error " + response.status +': ' + response.statusText + '.';
                                // throw "Validation remote: Callback failed.";
                            });


                        return deferred.promise;

                    };

                    // fire validation on init
                    scope.form[scope.fieldName].$validate();
                    // ngModel.$validate();

                });
            }
        }
    }
    validationRemote.$inject = ['$q', '$timeout', '$http', '$compile', 'transformToFormPost'];
    angular.module('app').directive('validationRemote', validationRemote);

}());
